<script>
import BTableWithAutocompleteAsync from '@/components/common/BTable/BTableWithAutocompleteAsync.vue'

export default {
  name: 'BTableWithAutocomplete',
  extends: BTableWithAutocompleteAsync,
  methods: {
    onActionAppend(data) {
      if (!data) return
      // Убеждаемся, что value - массив
      const currentValue = Array.isArray(this.value) ? this.value : []
      this.$emit('input', [data, ...currentValue])
      this.$emit('append', data)
    },
    onInput(data) {
      this.valueAutocomplete = []
      if (!data) return

      this.$emit('input', [].concat(data, this.value))
      this.$emit('append', data)
    },
  },
}
</script>
